<template>
  <div>
    <!-- -->
    <div class="marsTiltPanel marsTiltPanel-theme-blue">
      <img @click="closePanel" class="img-close" src="../../assets/GB.png" />
      <div class="marsTiltPanel-wrap">
        <div class="area">
          <div class="arrow-lt"></div>
          <div class="b-t"></div>
          <div class="b-r"></div>
          <div class="b-b"></div>
          <div class="b-l"></div>
          <div class="arrow-rb"></div>
          <div class="label-wrap">
            <PublicForm :width="'100px'" :formData="formData" :formList="cols" />
          </div>
        </div>
        <div class="b-t-l"></div>
        <div class="b-b-r"></div>
      </div>
      <div class="arrow"></div>
    </div>
  </div>
</template>

<script>
import { getCommonAjax } from "@/api/common";
export default {
  props: ["subData"],
  data() {
    return {
      formData: {},
      cols: [
        {
          label: "飞机型号:",
          cusprop: "device.planeType",
          component: "popContent",
        },
        {
          label: "定位时间:",
          cusprop: "deviceLocation.createTime",
          component: "popContent",
        },
        {
          label: "设备名称:",
          cusprop: "device.car.name",
          component: "popContent",
        },
        {
          label: "设备编号:",
          cusprop: "device.car.number",
          component: "popContent",
        },
        {
          label: "北斗卡号:",
          cusprop: "device.cardNumber",
          component: "popContent",
        },
        {
          label: "经度:",
          cusprop: "deviceLocation.longitude",
          component: "popContent",
        },
        {
          label: "纬度:",
          cusprop: "deviceLocation.latitude",
          component: "popContent",
        },
        {
          label: "高程(米):",
          cusprop: "deviceLocation.altitude",
          component: "popContent",
        },
        {
          label: "速度(km/h):",
          cusprop: "deviceLocation.speed",
          component: "popContent",
        },
      ],
    };
  },
  created() {
    this.getData();
    this.timeArr = this.getTimeStrings();
  },
  methods: {
    getTimeStrings(offset) {
      const now = new Date();
      const result = [];

      // 四小时前
      const fourHoursAgo = new Date(now.getTime() - 4 * 60 * 60 * 1000);
      result.push(this.formatCurrentTime(fourHoursAgo));

      // 一周前
      const oneWeekAgo = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000);
      result.push(this.formatCurrentTime(oneWeekAgo));

      // 一个月前
      const oneMonthAgo = new Date(now.getTime() - 30 * 24 * 60 * 60 * 1000);
      result.push(this.formatCurrentTime(oneMonthAgo));

      // 三个月前
      const threeMonthsAgo = new Date(now.getTime() - 90 * 24 * 60 * 60 * 1000);
      result.push(this.formatCurrentTime(threeMonthsAgo));

      // 一年前
      const oneYearAgo = new Date(now.getTime() - 365 * 24 * 60 * 60 * 1000);
      result.push(this.formatCurrentTime(oneYearAgo));

      return result;
    },
    formatCurrentTime(now) {
      const year = now.getFullYear(); // 获取年份
      const month = String(now.getMonth() + 1).padStart(2, "0"); // 获取月份，并补零
      const day = String(now.getDate()).padStart(2, "0"); // 获取日期，并补零
      const hours = String(now.getHours()).padStart(2, "0"); // 获取小时，并补零
      const minutes = String(now.getMinutes()).padStart(2, "0"); // 获取分钟，并补零
      const seconds = String(now.getSeconds()).padStart(2, "0"); // 获取秒钟，并补零

      // 格式化输出
      const formattedTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      return formattedTime;
    },
    closePanel() {
      this.$parent.close();
    },
    addTIME() {
      let line = localStorage.getItem("QueryTime") || "line1";
      if (line == "line1") {
        this.formData.deviceLocation.createTime = this.timeArr[0];
      }
      if (line == "line2") {
        this.formData.deviceLocation.createTime = this.timeArr[1];
      }
      if (line == "line3") {
        this.formData.deviceLocation.createTime = this.timeArr[2];
      }
      if (line == "line4") {
        this.formData.deviceLocation.createTime = this.timeArr[3];
      }
      if (line == "line5") {
        this.formData.deviceLocation.createTime = this.timeArr[4];
      }
    },
    addFJLX() {
      //运-5B-北大荒
      let type1 = ["912112", "912113", "912114"];
      //钻石DA40
      let type2 = ["912094"];

      //空中国王C90
      let type3 = ["912063"];
      let cardNumber = this.formData.device.cardNumber + "";
      if (type1.includes(cardNumber)) {
        this.formData.cardType = "运-5B";
      }

      if (type2.includes(cardNumber)) {
        this.formData.cardType = "钻石DA40";
      }

      if (type3.includes(cardNumber)) {
        this.formData.cardType = "空中国王C90";
      }

      this.formData.cardType = this.formData.cardType || "赛斯纳C-172R";
    },
    updateOther(item, curPos) {
      if (!this.formData || !this.formData.deviceLocation) {
        return;
      }
      //console.log(item)
      if (item) {
        if (!curPos) {
          curPos = {
            x: item.longitude,
            y: item.latitude,
            z: item.altitude,
          };
        }
        let lon_arr = this.formatDegree(Number(curPos.x));
        let lat_arr = this.formatDegree(Number(curPos.y));
        this.formData.deviceLocation.longitude = `${lon_arr[0]}°${lon_arr[1]}′${lon_arr[2]}″`;
        this.formData.deviceLocation.latitude = `${lat_arr[0]}°${lat_arr[1]}′${lat_arr[2]}″`;
        this.formData.deviceLocation.altitude = Number(curPos.z).toFixed(2);
        this.formData.deviceLocation.speed = item.speed;
        this.formData.deviceLocation.createTime = item.createTime;
      }
    },
    update(x, y, z, item) {
      if (this.hasData) {
        return;
      }
      if (!this.formData || !this.formData.deviceLocation || !this.formData.device) {
        return;
      }

      let lon_arr = this.formatDegree(x);
      let lat_arr = this.formatDegree(y);

      this.formData.deviceLocation.longitude = `${lon_arr[0]}°${lon_arr[1]}′${lon_arr[2]}″`;
      this.formData.deviceLocation.latitude = `${lat_arr[0]}°${lat_arr[1]}′${lat_arr[2]}″`;
      this.formData.deviceLocation.altitude = Number(z).toFixed(2);

      if (item) {
        this.formData.deviceLocation.speed = item.speed;
        this.formData.createTime = item.createTime;
      }
      // if (!item) {
      //   let s = this.getRandomInt(200, 300);
      //   this.formData.deviceLocation.speed = s.toFixed(0);
      //   this.hasData = true;
      // }
      // this.addFJLX();
      // this.addTIME();
    },
    getRandomInt(min, max) {
      min = Math.ceil(min);
      max = Math.floor(max);
      return Math.floor(Math.random() * (max - min + 1)) + min;
    },
    getData() {
      getCommonAjax("/device/getDeviceDetail", {
        cardNumber: this.subData,
      })
        .then((res) => {
          this.formData = res.result;

          if (!this.formData || !this.formData.deviceLocation || !this.formData.device) {
            return;
          }

          let lon_arr = this.formatDegree(this.formData.deviceLocation.longitude);
          let lat_arr = this.formatDegree(this.formData.deviceLocation.latitude);

          this.formData.deviceLocation.longitude = `${lon_arr[0]}°${lon_arr[1]}′${lon_arr[2]}″`;
          this.formData.deviceLocation.latitude = `${lat_arr[0]}°${lat_arr[1]}′${lat_arr[2]}″`;
          // this.addFJLX();
          // this.addTIME();
        })
        .catch((err) => {
          console.error(err);
        });
    },

    formatDegree(value) {
      value = Math.abs(value);
      var v1 = Math.floor(value); //度
      var v2 = Math.floor((value - v1) * 60); //分
      var v3 = Math.round(((value - v1) * 3600) % 60); //秒
      return [v1, v2, v3];
    },
  },
};
</script>

<style scoped>
.marsTiltPanel-wrap {
  position: relative;
  padding: 30px;
  overflow: hidden;
}
.marsTiltPanel .img-close {
  width: 26px;
  position: absolute;
  right: 12px;
  top: 10px;
  z-index: 999;
  cursor: pointer;
  pointer-events: all;
}
.marsTiltPanel-theme-blue .area {
  background-image: linear-gradient(
      135deg,
      transparent 30px,
      #28bbf06c 30px,
      #28bbf06c 50%,
      transparent 50%
    ),
    linear-gradient(
      -45deg,
      transparent 30px,
      #28bbf06c 30px,
      #28bbf06c 50.1%,
      transparent 50%
    );
}

.marsTiltPanel .area {
  position: relative;
  min-width: 180px;
}

.marsTiltPanel-theme-blue .b-t,
.marsTiltPanel-theme-blue .b-r,
.marsTiltPanel-theme-blue .b-b,
.marsTiltPanel-theme-blue .b-l,
.marsTiltPanel-theme-blue .b-t-l,
.marsTiltPanel-theme-blue .b-b-r {
  background-color: #29baf1;
  box-shadow: 0 0 10px 2px #29baf1;
}

.marsTiltPanel .b-t {
  position: absolute;
  top: 0;
  left: 44px;
  right: 0;
  height: 1px;
  z-index: 10;
}

.marsTiltPanel .b-r {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 44px;
  width: 1px;
  z-index: 10;
}

.marsTiltPanel .b-b {
  position: absolute;
  left: 0;
  right: 44px;
  bottom: 0;
  height: 1px;
  z-index: 10;
}

.marsTiltPanel .b-l {
  position: absolute;
  top: 44px;
  left: 0;
  bottom: 0;
  width: 1px;
  z-index: 10;
}

.marsTiltPanel .b-t-l {
  position: absolute;
  top: 0;
  left: 0;
  width: 1px;
  height: 62px;
  transform: rotate(45deg) translate(52px, -22px);
  z-index: 10;
}
.marsTiltPanel .b-b-r {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 1px;
  height: 62px;
  transform: rotate(45deg) translate(-52px, 22px);
  z-index: 10;
}
.marsTiltPanel .label-wrap {
  padding-left: 12px;
  color: #fff;
  font-size: 16px;
  white-space: nowrap;
  overflow: hidden;
}

.marsTiltPanel .label-wrap {
  padding-left: 12px;
  color: #fff;
  font-size: 16px;
  white-space: nowrap;
  overflow: hidden;
}

.marsTiltPanel-theme-blue .arrow,
.marsTiltPanel-theme-blue .title::before {
  background-color: #28bbf0;
}

.marsTiltPanel .arrow {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 45px;
  height: 2px;
  transform: rotate(-45deg) translate(5px, -15px);
}
</style>
